import { Field } from '../../field';
import { Component } from '@angular/core';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-input-attachment',
  templateUrl: './input-attachment.component.html',
  styleUrls: ['./input-attachment.component.less'],
})
export class InputAttachmentComponent extends Field {
  isAttachmentDrawerVisible = false;
  baseUrl = g.apiBaseUrl;
  urlSuffix = g.getUrlSuffix();
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  preview() {
    window.open(
      g.apiBaseUrl +
        'media/previewfile?path=' +
        encodeURIComponent(this.recordProperty.ValueAsObject?.replaceAll('#', '_HASH_')) +
        '&' +
        g.getUrlSuffix()
    );
  }

  clearAttachment() {
    LayoutService.setValue(
      this.recordProperty,
      '',
      this.layoutService,
      this.recordModel,
      this.lineId,
      this.sectionTagName,
      this.moduleStructure
    );
  }
}
